import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Box, Typography, TextField, Button, Alert, Stack } from '@mui/material'
import Wrapper from '../components/Wrapper'
import { submitSupportTicket } from '../services/supportService'

const Support = () => {
  const navigate = useNavigate()
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  const canSubmit = subject.trim().length > 0 && message.trim().length >= 10

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!canSubmit) return
    setSubmitting(true)
    setError(null)

    try {
      await submitSupportTicket({
        subject: subject.trim(),
        message: message.trim()
      })
      setSuccess(true)
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Failed to submit support ticket'
      )
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Wrapper>
      <Typography variant='h5' component='h1' sx={{ mb: 2 }}>
        Get Support
      </Typography>

      <Alert severity='info' sx={{ mb: 3 }}>
        If you have a dispute about a specific dive (e.g. no-show, incorrect
        charge, safety concern), please raise it directly on the dive in the app
        via the &quot;Raise Dispute&quot; button on the dive detail page.
      </Alert>

      {success ? (
        <Alert severity='success'>
          Your support ticket has been submitted. We&apos;ll get back to you as
          soon as possible.
        </Alert>
      ) : (
        <Box component='form' onSubmit={handleSubmit}>
          <Stack spacing={2}>
            {error && <Alert severity='error'>{error}</Alert>}
            <TextField
              label='Subject'
              value={subject}
              onChange={e => setSubject(e.target.value)}
              fullWidth
              required
              placeholder='Brief summary of your issue'
            />
            <TextField
              label='Message'
              value={message}
              onChange={e => setMessage(e.target.value)}
              multiline
              rows={5}
              fullWidth
              required
              helperText='Please provide at least 10 characters'
              placeholder='Describe your issue in detail...'
            />
            <Button
              type='submit'
              variant='contained'
              disabled={!canSubmit || submitting}
              fullWidth
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </Button>
          </Stack>
        </Box>
      )}
    </Wrapper>
  )
}

export default Support
